export const redisCacheKeys = {
  Role: {
    OPERATION_LIST: 'role_operation_list',
    OPERATION: 'role_operation',
    AIO_BUDDY_LIST: 'aio_buddy_list',
    AIO_BUDDY: 'aio_buddy',
  },
  Menu: {
    PUBLISHED_MENU: 'published_menu',
  },
  screen: (serialNumber: string) => `screen_${serialNumber}`,
  RestaurantDevicesSerialNumber: (serialNumberHash: string) => `restaurantDevices_${serialNumberHash}`,
  ImportGuestsTotal: 'import_guests_total',
  ImportGuestsInserted: 'import_guests_inserted',
  GetCachedRestaurant: 'getCachedRestaurant',
  // NOTE: Bump the `_v{n}` suffix whenever the `GeneralSettings` entity schema changes
  // (column added / renamed / removed). Old cached entries become orphaned and TTL-expire
  // naturally, so no explicit invalidation / DB scan is needed — the first read after deploy
  // is a normal cache miss. Current version bumped for `isWeeklyOtAllowed`.
  GetCachedGeneralSettings: 'getCachedGeneralSettings_v2',
  GetCachedGoogleIntegration: 'getCachedGoogleIntegration',
  GetCachedYelpIntegration: 'getCachedYelpIntegration',
  GetCachedOnlineOrderingSettings: 'getCachedOnlineOrderingSettings',
  GetCachedFinancialConfiguration: 'getCachedFinancialConfiguration',
  ImportGuestsUpdated: 'import_guests_updated',
  ImportGuestsFailed: 'import_guests_failed',
  ImportGuestsFailedRows: 'import_guests_failed_rows',
  ImportGuestsPlatform: 'import_guests_platform',
  ImportGiftCardsTotal: 'import_gift_cards_total',
  ImportGiftCardsInserted: 'import_gift_cards_inserted',
};
